import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Ruler, Search as SearchIcon, Shirt } from "lucide-react";

const Step = ({ num, icon: Icon, title, desc }) => (
    <div className="border-4 border-black bg-white shadow-brutal-lg p-6 flex flex-col gap-3">
        <div className="flex items-center justify-between">
            <span className="font-mono text-xs uppercase tracking-widest bg-black text-[#CCFF00] px-2 py-1">
                {num}
            </span>
            <div className="border-2 border-black p-2">
                <Icon className="w-5 h-5" />
            </div>
        </div>
        <p className="font-display text-2xl font-black uppercase tracking-tight leading-tight">
            {title}
        </p>
        <p className="font-mono text-sm leading-relaxed text-black/70">{desc}</p>
    </div>
);

export const HowItWorksSection = ({ profileId }) => (
    <section className="border-b-2 border-black bg-[#FDFBF7]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
            <div className="flex items-end justify-between mb-8 border-b-2 border-black pb-3 flex-wrap gap-3">
                <h2 className="font-display text-3xl md:text-5xl font-black uppercase tracking-tight">
                    How It Works
                </h2>
                <span className="font-mono text-xs uppercase tracking-widest">
                    / 3 steps · 90 seconds /
                </span>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <Step
                    num="01"
                    icon={Ruler}
                    title="Drop Your Stats"
                    desc="Height, weight, chest, waist, hips, inseam, shoe size + a selfie. Once. We keep it on your profile."
                />
                <Step
                    num="02"
                    icon={SearchIcon}
                    title="Search Across Stores"
                    desc="Tell us what you want. We scan Zara, H&M, ASOS, Nike, Adidas, SHEIN, Uniqlo, Urban Outfitters — and show only what fits."
                />
                <Step
                    num="03"
                    icon={Shirt}
                    title="Order in One Cart"
                    desc="Buy from multiple stores through Fits Me — with our partner discounts — and we route each item to its supplier."
                />
            </div>
            <div className="mt-10 flex flex-wrap gap-3 items-center">
                <Link
                    to="/profile"
                    data-testid="how-cta-btn"
                    className="bg-[#CCFF00] border-2 border-black px-6 py-3 font-bold uppercase tracking-widest shadow-brutal btn-press inline-flex items-center gap-2"
                >
                    {profileId ? "Update my profile" : "Start my profile"} <ArrowRight className="w-4 h-4" />
                </Link>
                <span className="font-mono text-[11px] uppercase tracking-widest text-black/60">
                    Takes under a minute · No password required
                </span>
            </div>
        </div>
    </section>
);
